import { ALIAS_FOR_NULL_VALUES } from 'src/constants/filter-values'

type ValidParams = string | number
type InvalidParams = null | undefined
type ReturnValue = string

export function numberFormatter<T extends InvalidParams>(param: T): T
export function numberFormatter<T extends ValidParams>(param: T): ReturnValue
export function numberFormatter(
  number: ValidParams | InvalidParams,
): ReturnValue | InvalidParams {
  if (number === 'NaN') return ALIAS_FOR_NULL_VALUES
  if (number === null || number === undefined) {
    return number
  }
  if (isNaN(Number(number))) {
    return typeof number === 'string' ? number : number.toLocaleString()
  }
  return Number(Number(number).toFixed(2)).toLocaleString()
}
